import { ERROR_MESSAGES } from '@/shared/constants/error-messages';
import * as yup from 'yup';

export const initialValues = {
  packaging: '',
  direction: '',
  quantity: ''
};

export const otcMedicationValidationSchema = yup.object().shape({
  packaging: yup.string().required(ERROR_MESSAGES.REQUIRED_FIELD_MISSING),
  direction: yup.string().required(ERROR_MESSAGES.REQUIRED_FIELD_MISSING),
  quantity: yup.string().nullable().required(ERROR_MESSAGES.REQUIRED_FIELD_MISSING)
});

export type OtcMedicationSchema = yup.InferType<typeof otcMedicationValidationSchema>;
